import React from "react";
import HalideLanding from "../components/ui/demo";

const Main = () => {
  return <HalideLanding />;
};

export default Main;
